<template>
  <div
    :class="[
      'ord-row',
      darkRow ? 'dark' : null,
    ]"
  >
    <div class="ao-table-body">
      <div :class="['grid-item js-s', bold ? 'sac__font-14 bold' : '']">
        {{ name }}
      </div>
      <div class="grid-item js-c">
        {{ quantity }}
      </div>
      <div class="grid-item js-e">
        {{ total }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderLineItem',
  props: {
    bold: Boolean,
    darkRow: Boolean,
    name: String,
    quantity: [String, Number],
    total: [String, Number],
  },
};
</script>

<style lang="scss">
.ord-row {
  &:nth-child(odd) {
    padding: 8px;
    font-size: 14px;
    background-color: $NBLUE15;
  }

  &:nth-child(even) {
    padding: 8px;
    font-size: 14px;
    background-color: $WHITE;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &.dark {
    background-color: #002E63;
    color: $WHITE;
  }

  .ao-table-body {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr;
  }
}
</style>
